export const ScanKind = {
  product: "product",
  inventoryItem: "inventoryItem",
} as const;
export type ScanKind = (typeof ScanKind)[keyof typeof ScanKind];

export const LICENSE_PLATE_SCAN_REQUIRED =
  "LICENSE_PLATE_SCAN_REQUIRED" as const;
